<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Haushaltsmitglieder sperren
            </h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <div class="centerAndJustify">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Haushalte eingrenzen auf</mat-label>
                    <mat-select [formControl]="this.filterForm.controls.filterByTypes">
                        <mat-select-trigger>
                            <span *ngIf="this.filterForm.controls.filterByTypes.value != null ">
                                {{this.filterForm.controls.filterByTypes.value | translateFilterHousehold :
                                'filterByTypes'}}
                            </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let sortOption of sortOptionsState" [value]="sortOption.value">
                            {{sortOption.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row marginBottom2Rem">
        <div class="col-sm-12">
            <button mat-button mat-raised-button color="accent" (click)="filterHouseHolds()">
                Anwenden
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFilter()" style="margin-left: 15px;"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12" *ngFor="let houseHold of houseHoldList" style="    margin-bottom: 15px;">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-title> Haushalt von
                    {{houseHold.defaultCustomer.account.displayName}} ({{houseHold.defaultAccountRef}})</mat-card-title>
                <mat-card-content>
                    <div *ngFor="let customer of houseHold.customers"
                        style="display: flex;align-items: center;position: relative;">
                        <mat-list-item>
                            <mat-icon matListItemIcon class="icon"
                                *ngIf="customer.customerType != 'MAINCUSTOMER'">supervised_user_circle</mat-icon>
                            <mat-icon matListItemIcon class="icon"
                                *ngIf="customer.customerType == 'MAINCUSTOMER'">person_pin</mat-icon>
                            <div matListItemTitle>{{customer.account.displayName}} ({{customer.customerType}})</div>
                            <div matListItemLine>{{customer.account.lastModified | date}}</div>
                        </mat-list-item>
                        <button mat-icon-button [matMenuTriggerFor]="menu" class="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="deactivateRequestUserById(houseHold)" *ngIf="customer.account.state != 'DISABLE_REQUEST'">
                                <mat-icon>cancel</mat-icon>
                                <span>
                                    Kunde für Sperrung vormerken
                                </span>
                            </button>
                            <button mat-menu-item (click)="neverdeactivateUserById(houseHold)" *ngIf="customer.account.state != 'DISABLE_REQUEST'">
                                <mat-icon>check</mat-icon>
                                <span>
                                    Nie sperren</span>
                            </button>

                            <button mat-menu-item (click)="reactivateUserById(houseHold)" *ngIf="customer.account.state == 'DISABLE_REQUEST'">
                                <span>   
                                Sperrung rückgängig machen
                                </span>
                            </button>


                            <button mat-menu-item (click)="deactivateUserById(houseHold)" *ngIf="customer.account.state == 'DISABLE_REQUEST'">
                                <mat-icon>cancel</mat-icon>
                                <span>
                                    Endgültig sperren
                                </span>
                            </button>

                        

                        
                        
                        </mat-menu>
                    </div>


                </mat-card-content>

            </mat-card>
        </div>
    </div>
</div>